import { useState } from 'react';
import { AvailableNodes, NodeType, TemplateStatus } from '../../../../helper/constant';
import { Handle, useReactFlow } from '@xyflow/react';
import { useAIModelContext } from '../../../../context/ai-model.context';
import { useAIWorkflowContext } from '../../../../context/ai-workflow.context';
import { renderNodeIcon } from '../../../../helper/helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import NodeStatus from '../components/NodeStatus';
import InputAgentModal from '../components/InputAgentModal';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const InputNode = ({ data, id, workflow }) => {
    const { updateRightMenu } = useAIModelContext();
    const { updateSelecteNode, workflowEdit, workflowExecution } = useAIWorkflowContext();
    const [inputArgs, setInputArgs] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleNodeClick = () => {
        updateRightMenu(true);
        updateSelecteNode({ id, data })
    };

    const renderNodeDetails = () => {
        if (data && data.input_type)
            return (
                <div className='px-2 pb-2 d-flex flex-column node-details gap-1'>
                    <p className='p-0 m-0 text-black'>Input: <span className='text-secondary capitalize'>{data.input_type}</span></p>
                    {data.scrapping_url && <p className='p-0 m-0 text-black'>URL: <span className='text-secondary'><a href={data.scrapping_url} target='_blank'>Scrapping URL</a></span></p>}
                    {data.zone && <p className='p-0 m-0 text-black'>Zone: <span className='text-secondary'>{data.zone}</span></p>}
                    {data.sensor && <p className='p-0 m-0 text-black'>Sensor: <span className='text-secondary'>{data.sensor}</span></p>}
                    {(data.workflows && data.workflows.length) && <>
                        {
                            data.workflows.map(i => {
                                return (
                                    <div key={i.id} className='mb-2'>
                                        <p className=' p-0 m-0 text-secondary'>{i.name}</p>
                                        {i.agents && i.agents.length > 0 && i.agents.map(agent => (
                                            <span key={agent.id} className='badge bg-light white-space-break'>{agent.model_name}</span>
                                        ))}
                                    </div>
                                )
                            })
                        }
                    </>
                    }
                    {renderViewResults()}
                </div>
            )
    }

    const renderDeleteButton = () => {
        if (workflowEdit)
            return <NodeDeleteButton id={id} name={workflow.name} />
    }

    const onResult = (info) => {
        try {
            if (info && info.argument) {
                const arg = JSON.parse(info.argument);
                setInputArgs(arg);
            }
        } catch (e) {
            console.log(e);
            setInputArgs(info.argument)
        }
    }

    const renderInputModal = () => {
        return (
            <InputAgentModal
                id={id}
                name={data.input_type}
                data={inputArgs}
                showModal={showModal}
                setShowModal={setShowModal} />
        )
    }

    const onShowInputModal = (e) => {
        e.stopPropagation();
        setShowModal(true);
    }

    const renderViewResults = () => {
        if (workflow && workflow.status === TemplateStatus.COMPLETED && workflowExecution && workflowExecution.executionId) {
            const tooltipResult = (
                <Tooltip className='agent-tooltip'>
                    Show Input
                </Tooltip>
            );
            return (
                <OverlayTrigger placement="top" overlay={tooltipResult}>
                    <Link
                        onClick={onShowInputModal}
                        className='align-self-center fs-10'>{<FontAwesomeIcon icon={faEye} />} View</Link>
                </OverlayTrigger>)
        }
    }

    const render = () => {
        if (data)
            return (
                <div className={`dndnode d-flex flex-column gap-1 ${NodeType.InputNode}`} onClick={handleNodeClick}
                >
                    {renderDeleteButton()}
                    {data &&
                        <div className='p-2 m-0 node-title d-flex justify-content-between align-items-center' style={{ backgroundColor: AvailableNodes[0].color }}>
                            <div className='d-flex align-items-center'>
                                {renderNodeIcon(data.type, 25)}
                                <p className='p-0 m-0'>{data.label}</p>
                            </div>
                            {workflow.status === TemplateStatus.COMPLETED && <NodeStatus id={id} name={workflow.name} onResult={r => onResult(r)} />}
                        </div>
                    }
                    {renderNodeDetails()}
                    <Handle
                        type="source"
                        position="right"
                        style={{ background: '#555' }}
                        id={`${id}-source`}
                        isConnectable={true}
                    />
                    {renderInputModal()}
                </div >
            )
    }
    return render();
}

export default InputNode

export const NodeDeleteButton = ({ id }) => {

    const { setNodes, setEdges } = useReactFlow();

    const handleDelete = (e) => {
        e.stopPropagation();
        setNodes((nodes) => nodes.filter((node) => node.id !== id));
        setEdges((edges) => edges.filter((edge) => edge.source !== id && edge.target !== id));
    };

    return (
        <button
            className='btn-clear btn-node-close px-0'
            onClick={handleDelete}><FontAwesomeIcon icon={faXmarkCircle} size='xs' /></button>
    )
}